import { formatLocale } from 'd3-format';
var currencyCodeToSymbol = {
  GBP: '£',
  EUR: '€',
  USD: '$'
};
export default function format(currencyCode, amount) {
  var useLetterCode = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  return useLetterCode ? formatWithCurrencyCode(amount, currencyCode) : formatPreferringSymbolsWhenKnown(amount, currencyCode);
}
export function formatPreferringSymbolsWhenKnown(amount, currencyCode) {
  var symbol = currencyCodeToSymbol[currencyCode || 'GBP'];
  return formatCurrencyAmount(amount, symbol ? symbol : currencyCode ? "".concat(currencyCode, " ") : 'GBP ');
}
export function formatWithCurrencyCode(amount, currencyCode) {
  return formatCurrencyAmount(amount, currencyCode ? "".concat(currencyCode, " ") : 'GBP ');
}
function formatCurrencyAmount(amount, currency) {
  if (typeof amount === 'string') return formatCurrencyAmountFromString(amount, currency);
  var formatter = formatLocale({
    decimal: '.',
    thousands: ',',
    grouping: [3],
    currency: [currency, '']
  }).format('$,.2f');
  return formatter(amount || '0');
}
function formatCurrencyAmountFromString(amount, currency) {
  return amount[0] === '-' ? "-".concat(currency).concat(amount.slice(1)) : currency + amount;
}